import { NO_ELEMENT } from 'utils';
import { registry } from './registry';
import Markdown from 'components/Shared/Markdown';
import styles from './styles.scss';

const findMacro = /(<\?UMBRACO_MACRO).*(\/>)/gi;
const findParams = /(\w*="(?:[^"\\]|\\")*")/giu;

const getTags = (text: string) => {
  const splitString = 'umbraco_macro_split_string';

  return text
    .replace(findMacro, match => {
      return `${splitString}${match}${splitString}`;
    })
    .split(splitString);
};

interface Macro {
  macroAlias: string;
}

export const isMacro = (macro: unknown): macro is Macro => 'macroAlias' in (macro as Macro);

const getCustomComponent = (macro: unknown) => {
  if (!isMacro(macro)) {
    return NO_ELEMENT;
  }

  const Component = registry[macro.macroAlias];

  return Component ? <Component {...(macro as unknown as Record<string, unknown>)} /> : NO_ELEMENT;
};

const getComponents = (tags: string[]) => {
  return tags.map((tag, index) => {
    const macro = tag.match(findMacro);

    if (!macro) {
      return <Markdown key={index} content={tag} className={styles.article} tag="div" />;
    }

    const params = tag.match(findParams);

    if (!params) {
      return NO_ELEMENT;
    }

    const macroParameter = params.reduce((params, param) => {
      const [key, value] = param.split('=');
      const valueWithoutQuote = value.replace(/"/g, '');
      return { ...params, [key]: valueWithoutQuote };
    }, {});

    return getCustomComponent(macroParameter);
  });
};

export const getMacro = (content: string) => {
  const tags = getTags(content);
  return getComponents(tags);
};

export const Macro = ({ content }: { content: string }) => <>{getMacro(content)}</>;
